import { styled } from "@mui/system";
import { Select, Typography } from "@mui/material";

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const StyledSelect = styled(Select)({
  width: "100%",
  backgroundColor: "rgba(249, 249, 250, 0.6)",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#0008281C",
  },
});

export const JobAdTitleContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-end",
  gap: "0.5rem",
  marginBottom: "1rem",
  backgroundColor: "transparent",
  "&:hover": { backgroundColor: "transparent" },
  color: "currentcolor",
  border: "none",
  width: "auto",
  textTransform: "none",
}));

export const JobAdTitle = styled(Typography)(() => ({
  fontSize: "32px",
  fontWeight: 600,
  lineHeight: 1,
  overflowWrap: "anywhere",
}));
